import { Component, OnInit, Input } from '@angular/core';
import { OidcSecurityService } from '../../auth/services/oidc.security.service';
import { NoteWidgetContainerService } from './note-widget-container.service';
import { NoteSearchModel } from '../models/note-related/NoteSearchModel';
import { NoteCreateModel } from '../models/note-related/NoteCreateModel';
import { PreloaderHandler, BLUE_FULL } from '../preloader/preloader-handler';
import { NotificationHandlerService } from '../notifications/notification-handler.service';

@Component({
    selector: 'note-widget-container',
    templateUrl: 'note-widget-container.component.html'
})

export class NoteWidgetContainerComponent implements OnInit {

    @Input() entityId: string;
    public allEntityNotes: NoteSearchModel[];
    private newNote: NoteCreateModel;
    public preloaderHandler: PreloaderHandler;

    private showCreate = false;

    constructor(private _widgetService: NoteWidgetContainerService,
        private _notificationService: NotificationHandlerService,
        public oidcSecurityService: OidcSecurityService) {
        let timeout = 850;
        let itemLoadCount = 1;
        this.preloaderHandler = new PreloaderHandler(itemLoadCount, timeout, BLUE_FULL);
    }

    ngOnInit(): void {
        if (this.entityId) {
            this.getData();
        }
    }

    public getData() {
        this.allEntityNotes = null;
        this.preloaderHandler.reset();
        this._widgetService
            .Get(this.entityId)
            .subscribe(data => {
                this.allEntityNotes = data
            },
            error => {
                this.oidcSecurityService.handleError(error),
                    this._notificationService.handleError(error)
            },
            () => {
                this.preloaderHandler.itemLoaded();
            });
    }

    public isNoNotes(): boolean {
        return (!this.allEntityNotes || this.allEntityNotes.length < 1) && this.preloaderHandler.isLoaded;
    }

    private toggleCreate(): void {
        this.showCreate = !this.showCreate;
        if (this.showCreate) {
            this.newNote = {
                EntityId: this.entityId,
                NoteContent: '',
                UserId: 0
            }
            this.preloaderHandler.itemLoaded();
        } else {
            this.newNote = null;
            this.preloaderHandler.reset();
        }
    }

    private removeNote(data: NoteSearchModel): void {
        let index: number = this.allEntityNotes.indexOf(data);
        if (index !== -1) {
            this.allEntityNotes.splice(index, 1);
        }
    }

    private newNoteIsValid(): boolean {
        return (this.newNote.NoteContent.length > 0);
    }

    private saveData(): void {
        if (this.newNoteIsValid()) {
            this.preloaderHandler.reset();
            this._widgetService
                .Create(this.newNote)
                .subscribe(data => {
                },
                error => {
                    this.oidcSecurityService.handleError(error),
                        this._notificationService.handleError(error)
                },
                () => {
                    this.toggleCreate(),
                    this.preloaderHandler.itemLoaded(),
                    this.getData()
                });
        }
    }
}



// WEBPACK FOOTER //
// ./angularApp/app/shared/note-widget-container/note-widget-container.component.ts